var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 147 146",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m146.81 36.414c0-20.04-16.269-36.31-36.309-36.31h-73.727c-20.04 0-36.309 16.27-36.309 36.31v72.619c0 20.039 16.269 36.309 36.309 36.309h73.727c20.04 0 36.309-16.27 36.309-36.309v-72.619z",
    fill: "#ebebeb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.0281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.92608 0 0 .92608 8.9656 4.7562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.551 52.591c9.407 6.721 20.931 10.676 33.377 10.676v-23.939c-2.355 1e-3 -4.705-0.245-7.009-0.733v18.843c-12.446 0-23.968-3.954-33.378-10.675v48.852c0 24.438-19.821 44.247-44.27 44.247-9.122 0-17.601-2.756-24.645-7.484 8.039 8.216 19.25 13.312 31.653 13.312 24.451 0 44.273-19.809 44.273-44.248v-48.851h-1e-3zm8.647-24.151c-4.808-5.249-7.964-12.033-8.647-19.533v-3.079h-6.643c1.673 9.532 7.376 17.676 15.29 22.612zm-69.107 85.185c-2.687-3.52-4.138-7.826-4.132-12.253 0-11.177 9.067-20.24 20.251-20.24 2.085 0 4.157 0.319 6.143 0.949v-24.474c-2.321-0.318-4.664-0.453-7.006-0.403v19.049c-1.988-0.63-4.061-0.95-6.146-0.948-11.185 0-20.251 9.061-20.251 20.24 1e-3 7.904 4.532 14.747 11.141 18.08z",
    fill: "#ff004f",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.92608 0 0 .92608 8.9656 4.7562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.542 46.763c9.409 6.72 20.932 10.675 33.377 10.675v-18.844c-6.947-1.478-13.097-5.107-17.721-10.154-7.915-4.936-13.617-13.081-15.29-22.613h-17.447v95.614c-0.04 11.146-9.091 20.172-20.252 20.172-6.577 0-12.42-3.134-16.12-7.988-6.608-3.333-11.14-10.177-11.14-18.08 0-11.177 9.066-20.24 20.251-20.24 2.143 0 4.208 0.334 6.146 0.948v-19.049c-24.02 0.496-43.337 20.112-43.337 44.237 0 12.043 4.81 22.961 12.618 30.938 7.043 4.727 15.522 7.484 24.645 7.484 24.449 0 44.27-19.811 44.27-44.248v-48.852z",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.92608 0 0 .92608 8.9656 4.7562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m121.92 38.594v-5.094c-6.264 9e-3 -12.406-1.745-17.721-5.06 4.705 5.148 10.901 8.698 17.721 10.154zm-33.01-32.766c-0.16-0.912-0.282-1.829-0.367-2.749v-3.079h-24.091v95.614c-0.039 11.145-9.089 20.171-20.251 20.171-3.277 0-6.371-0.778-9.111-2.159 3.7 4.853 9.544 7.986 16.121 7.986 11.16 0 20.212-9.024 20.251-20.171v-95.613h17.448zm-38.562 51.376v-5.424c-2.013-0.275-4.042-0.413-6.074-0.412-24.452 0-44.273 19.81-44.273 44.246 0 15.32 7.79 28.822 19.628 36.764-7.808-7.977-12.618-18.895-12.618-30.937 0-24.125 19.317-43.741 43.337-44.237z",
    fill: "#00f2ea",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.3a6f548209e26ff1bba46edd4bb2161c.svg";
export { ForwardRef as ReactComponent };